// src/pages/AdminLogin.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

// 🔥 Apna logo import karo
import brandLogo from '../assets/logo-desktop.png';

const AdminLogin = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setIsLoading(true); // Loading chalu karo
    setError(null);     // Purane errors hatao
    
    try {
      const response = await axios.post('https://pickupdrop.dodigitals.in/api/admin/login', {
        email: email,
        password: password
      });

      if (response.data.token) {
        // 🔥 1. TOKEN KO LOCAL STORAGE MEIN SAVE KARO 🔥
        localStorage.setItem('adminToken', response.data.token);
        
        // 🔥 2. React Router ka useNavigate use karo (page reload hone se bachata hai) 🔥
        // replace: true se user back button dabake wapas login pe nahi aa payega
        navigate('/dashboard', { replace: true }); 
      }
    } catch (err) {
      // Alert ki jagah screen par error message dikhao
      setError(err.response?.data?.message || 'Login failed. Please check your details.');
    } finally {
      setIsLoading(false); // API call khatam, loading band karo
    }
  };

  return (
    <div className="login-wrapper">
      <div className="login-box">
        
        {/* 🔥 Placeholder hata kar Asli Logo laga diya */}
        <img 
          src={brandLogo} 
          alt="PickupDrop Brand" 
          style={{ height: '50px', width: 'auto', margin: '0 auto 24px auto', display: 'block' }} 
        />
        <p className="login-subheading">Sign in to manage PickupDrop.</p>
        
        <form onSubmit={handleLogin}>
          {/* 🔥 Agar koi error aata hai, toh is red dabbe mein dikhega 🔥 */}
          {error && (
            <div style={{ backgroundColor: '#FEE2E2', color: '#DC2626', padding: '12px', borderRadius: '8px', fontSize: '13px', marginBottom: '20px', fontWeight: '500' }}>
              {error}
            </div>
          )}
          
          <div className="form-group">
            <label className="form-label">Email Address</label>
            <input 
              type="email" 
              placeholder="admin@pickupdrop.com" 
              className="modern-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          
          <div className="form-group">
            <label className="form-label">Password</label>
            <input 
              type="password" 
              placeholder="••••••••" 
              className="modern-input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          
          <button type="submit" className="modern-btn" disabled={isLoading}>
            {isLoading ? "Authenticating..." : "Sign In"}
          </button>
        </form>

      </div>
    </div>
  );
};

export default AdminLogin;